
import objectPath from 'object-path';
import uuid from 'uuid';

import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {AnyAction} from "redux";

export default function reduce(state = defaultState, action: AnyAction): AlmeState {
    const newState = { ...state };
    switch (action.type) {
        case 'FORCE_WINDOW_RENDER':
            objectPath.set(newState, action.payload.stateLocation, uuid.v4());
            return newState;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/skinner/src/reducers/index.ts